module.exports = __webpack_public_path__ + "img/gettedticket1.f115b284.png";